// Keys shared between hooks, kept free of context imports so a hook that
// only needs the key can be tested without the auth client.
export const screenerUsageQueryKey = ["screener", "usage"] as const;
export const savedScreensQueryKey = ["screener", "saved"] as const;
/** Every new-matches read of one saved screen, whatever its scope. */
export const screenNewMatchesPrefix = (screenId: string) =>
  ["screener", "new-matches", screenId] as const;
